import React, { useState, useEffect } from 'react'
import ReactGA from 'react-ga4';
import { Col, Row, Alert, Form } from 'react-bootstrap';
import styles from './candidateSearch.module.scss';
import { logout } from '../../../services/util/auth';

import CustomNavbar from '../customNavbar';
import { CustomCheckBox } from '../../shared/customCheckBox';
import { CustomButton } from '../../shared/customButton';
import { CustomConfirmationBox } from '../../shared/customConfirmationBox';
import { CustomConfirmationWithDropdownBox } from '../../shared/customConfirmationWithDropdownBox';
import { CustomTextField } from '../../shared/customTextField';
import { useParams, useNavigate } from 'react-router-dom';
import { getAllPipelineList, getCandidateFilters, getFilteredCandidates, getCandidateSearchList } from '../../../services/util/hiringpipeline/candidateFilter';
import { failFilteredCandidates, failCandidateManually, bypassCandidateManually, getCandidateDetails} from '../../../services/util/hiringpipeline/candidates'
import { getPresignedUrlToViewCandidateCV } from '../../../services/util/hiringpipeline/candidates';
import Select from 'react-select'
import { Formik } from 'formik';
import ReactPaginate from 'react-paginate';
import CSSLoader from '../../shared/cssLoader';
import SendBulkEmailsToCandidates from '../common/sendBulkEmailsToCandidates/index';
import makeAnimated from 'react-select/animated';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import Avatar from 'react-avatar';
import { Helmet } from 'react-helmet';


const CandidateSearch = (props) => {


    const animatedComponents = makeAnimated();
    //items per page count
    const itemsPerPage = 10;

    let [originalData, setOriginalData] = useState([]);
    let [filteredtableData, setFilteredTableData] = useState([]);

    let [isPageLoading, setPageLoading] = useState(false); // loading entire page (when pipeline change)
    let [isDataLoading, setDateLoading] = useState(false); // loading candidate table data
    let [isSearchDataLoading, setSearchDateLoading] = useState(false); // loading candidate table data for search
    let [isFilterSettingsLoading, setFilterSettingLoading] = useState(false); // loading filter settings

    // filter objects
    let [rootFilterSettingsObj, setRootFilterSettingsObj] = useState({}); // root level filter object
    let [filterLevelOneObj, setFilterLevelOneObj] = useState({});
    let [filterLevelTwoObj, setFilterLevelTwoObj] = useState({});
    let [filterLevelThreeObj, setFilterLevelThreeObj] = useState({});


    let [selectedFilterLevelOneDropDownObj, setSelectedFilterLevelOneDropDownObj] = useState(null); // level one filter object
    let [selectedFilterLevelTwoDropDownObj, setSelectedFilterLevelTwoDropDownObj] = useState(null); // level two  filter object
    let [selectedFilterLevelThreeDropDownObj, setSelectedFilterLevelThreeDropDownObj] = useState(null); // level three  filter object

    // drop down objects arrays for filters
    let [pipelineListDropDownArray, setPipelineListDropDownArray] = useState({});
    let [pipelineList, setPipelineList] = useState({});
    let [filterLevelOneDropDownArray, setFilterLevelOneDropDownArray] = useState([]);
    let [filterLevelTwoDropDownArray, setFilterLevelTwoDropDownArray] = useState([]);
    let [filterLevelThreeDropDownArray, setFilterLevelThreeDropDownArray] = useState([]);

    let [isLevelOneFilterError, setLevelOneFilterError] = useState(false);
    let [isLevelTwoFilterError, setLevelTwoFilterError] = useState(false);
    let [isLevelThreeFilterError, setLevelThreeFilterError] = useState(false);

    let [currentPipelineObj, setCurrentPipelineObj] = useState({});

    let [isFilterLevelOneAvailable, setFilterLevelOneAvailable] = useState(false);
    let [isFilterLevelTwoAvailable, setFilterLevelTwoAvailable] = useState(false);
    let [isFilterLevelThreeAvailable, setFilterLevelThreeAvailable] = useState(false);

    //table action states
    let [tableActions, setTableActions] = useState([]);

    //selected row count
    let [selectedRowCount, setSelectedRowCount] = useState(0);
    let [selectedCandidateIds, setSelectedCandidateIds] = useState([]);
    let [isSelectAllCandidate, setSelectAllCandidate] = useState(false);

    //Actions Submit Loading
    let [actionsSubmitLoading, setActionsSubmitLoading] = useState(false);

    //for the dropdown for manually pass to step
    let [defaultSelectBypassDropdownEvaluationStep, setDefaultSelectBypassDropdownEvaluationStep] = useState(null);
    let [candidateDetailsValues, setCandidateDetailsValues] = useState(null);
    let [bypassDropdownEvaluationSelectionTypes, setBypassDropdownEvaluationSelectionTypes] = useState(null);





    // candidate list for one page
    const [currentItems, setCurrentItems] = useState([]);
    //page count 
    const [pageCount, setPageCount] = useState(0);
    // Here we use item offsets; we could also use page offsets
    // following the API or data you're working with.
    const [itemOffset, setItemOffset] = useState(0);

    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let is_search_mode = ((params.get('is_search_mode') == 'true') || (params.get('is_search_mode') == true)) ? true : false;
    let selected_pipeline_id = (params.get('pipeline_id') == 'null') ? null : params.get('pipeline_id');
    let filter_level_one_url_paramater = (params.get('filter_level_one') == 'null') ? null : params.get('filter_level_one');
    let filter_level_two_url_paramater = (params.get('filter_level_two') == 'null') ? null : params.get('filter_level_two');
    let filter_level_three_url_paramater = (params.get('filter_level_three') == 'null') ? null : params.get('filter_level_three');
    let search_key = (params.get('search_key') == 'null') ? null : params.get('search_key'); //search by name or email
    let [currentSearchKey, setCurrentSearchKey] = useState(search_key);
    // setSearchValue(currentSearchKey)
    let [currentPipelineId, setCurrentPipelineId] = useState(selected_pipeline_id);
    let [isFilterRenderStatus, setIsFilterRenderStatus] = useState();
    // search values
    let [searchValue, setSearchValue] = useState(search_key);

    const history = useNavigate();

    let [candidateData, setCandidateData] = useState();

    let breadcrumb = [];
    let breacrumbText =''
    if (is_search_mode) {
        breadcrumb = [
            {
                pathname: 'Search Candidates',
                isActive: false,
                key: 1 + 'search-candidates'
            }
        ]
        breacrumbText = 'Search profiles from your candidate pool. You will see candidates from all pipelines, including ongoing and disabled pipelines'
    }
    else {
        breadcrumb = [
            {
                pathname: 'Candidate Filter',
                isActive: false,
                key: 1 + 'candidate-filter'
            }

        ]

        breacrumbText = 'Filter candidates within the pipeline. Use dropdowns to filter candidate profiles in different stages.'
    }


    // Action codes
    // Evaluation Stages
    const MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION = '10';
    const MANUALLY_REJECT_IN_EVALUATION = '20';
    const MANUALLY_PASS_FROM_FAILED_IN_EVALUATION = '30';
    // Filtered Stage
    const MARK_AS_OFFER_SENT_IN_FILTERD_STAGE = '110';
    const REJECT_IN_FILTERD_STAGE = '120';
    //Offer sent stage
    const MARK_AS_OFFER_DECLINED_IN_OFFER_STAGE = '210';
    const MARK_AS_OFFER_ACCEPTED_IN_OFFER_STAGE = '220';

    const SEND_BULK_EMAILS = '100';

    let defaultActionObject = {
        label: "Send Email",
        value: SEND_BULK_EMAILS
    }

    //Actions Modal states
    let [actionStateModal, setActionStateModal] = useState({
        is_open: false,
        candidate_id_set: [],
        action_state: ''
    });

    let [showBulkEmailsToCandidates, setShowBulkEmailsToCandidates] = useState(false);


    //on click filter button
    const onSubmitFilter = async (values) => { 
        let filter_one = values.filter_level_one ? values.filter_level_one.value : null;
        let filter_two = values.filter_level_two ? values.filter_level_two.value : null;
        let filter_three = values.filter_level_three ? values.filter_level_three.value : null;

        if (!filter_one) {
            setLevelOneFilterError(true)
        }
        else if (!filter_two && filterLevelOneObj && filterLevelOneObj.is_nested_filter_required) {
            setLevelTwoFilterError(true)
        }
        else if (!filter_three && filterLevelTwoObj && filterLevelTwoObj.is_nested_filter_required) {
            setLevelThreeFilterError(true)
        }
        else {
            currentPipelineId = values.pipeline.value;
            const searchString = (filter_one && filter_two && filter_three) ? `?pipeline_id=${currentPipelineId}&filter_level_one=${filter_one}&filter_level_two=${filter_two}&filter_level_three=${filter_three}` : (filter_one && filter_two && !filter_three) ? `?pipeline_id=${currentPipelineId}&filter_level_one=${filter_one}&filter_level_two=${filter_two}` : '';
            history({
                pathname: '/company/search-candidates',
                search: searchString,
            },{ replace: true });  
        }
        setIsFilterRenderStatus(prevIsFilterRenderStatus => !prevIsFilterRenderStatus);
    }
   
    const changeSelectedPipeline = async (selected_pipeline) => {
        setCurrentPipelineId(selected_pipeline)
        history({
            pathname: `/company/search-candidates`,
            search: `?pipeline_id=${selected_pipeline}&filter_level_one=null&filter_level_two=null&filter_level_three=null&search_key=null`
        },{ replace: true });
    }

    const applySearchKey = async () => {
        setCurrentSearchKey(searchValue.trimStart().trimEnd())
        history({
            pathname: `/company/search-candidates`,
            search: `?pipeline_id=null&filter_level_one=null&filter_level_two=null&filter_level_three=null&search_key=${searchValue.trimStart().trimEnd()}&is_search_mode=true`
        },{ replace: true });
    }


//pass candidates to upcoming evaluation step
    const manualPassToUpcomingStep = async (value) => {
        setActionsSubmitLoading(true);

        let respond = await bypassCandidateManually(actionStateModal.candidate_id_set, value.defaultSelectedType.value, value.reason);

        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            props.GetTaskValues();
            loadPageData();
        } else {
            setActionsSubmitLoading(false);
        }
    };


    //manually fail from filter step
    const manuallyFailFromFilterStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await failFilteredCandidates(actionStateModal.candidate_id_set, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            props.GetTaskValues();
            loadPageData();
        } else {
            setActionsSubmitLoading(false);
        }
    };

    //failcandidates from current pipeline step
    const manuallyFailFromCurrentStep = async (value) => {
        setActionsSubmitLoading(true);
        let respond = await failCandidateManually(actionStateModal.candidate_id_set, selectedFilterLevelTwoDropDownObj.value, value.reason);
        if (respond.success === true) {
            setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] });
            setActionsSubmitLoading(false);
            props.GetTaskValues();
            loadPageData();
        } else {
            setActionsSubmitLoading(false);
        }
    };



    //load page data function (initial call)
    const loadPageData = async () => {
        setPageLoading(true);

        let pipelineDataArray = [];

        let respond = await getAllPipelineList(currentPipelineId);
        if (respond.success === true) {
            //set all pipeline list
            setPipelineList(respond.data);
            for (let index = 0; index < respond.data.length; index++) {
                let piplelineObj = {
                    label: respond.data[index].label,
                    value: respond.data[index].value
                }
                pipelineDataArray.push(piplelineObj);
            }
            setPipelineListDropDownArray(pipelineDataArray);

            if (currentSearchKey) {
                let respond = await getCandidateSearchList(currentSearchKey);
                if (respond.success === true) {
                    let filteredCandidateArray = [];
                    for (let index = 0; index < respond.data.length; index++) {
                        let filteredCandidateObj = {
                            id: respond.data[index].id,
                            name: respond.data[index].name,
                            email: respond.data[index].email,
                            phone: respond.data[index].phone,
                            overall_marks: respond.data[index].overall_marks,
                            state: respond.data[index].state,
                            candidate_profile_url: respond.data[index].candidate_profile_url,
                            state_code: respond.data[index].state_code,
                            evaluation_steps: respond.data[index].evaluation_steps,
                            current_stage_name: respond.data[index].current_stage_name,
                            last_stage_name: respond.data[index].last_stage_name,
                            hiring_position: respond.data[index].hiring_position,
                            pipeline_name: respond.data[index].pipeline_name,
                            is_enabled: false
                        }
                        filteredCandidateArray.push(filteredCandidateObj);
                    }
                    setOriginalData(filteredCandidateArray);
                    const endOffset = itemOffset + itemsPerPage;
                    setCurrentItems(filteredCandidateArray.slice(itemOffset, endOffset));
                    setPageCount(Math.ceil(filteredCandidateArray.length / itemsPerPage));
                    setFilteredTableData(filteredCandidateArray);
                    setPageLoading(false);
                } else {
                    setSearchDateLoading(false)
                    history({
                        pathname: `/company/search-candidates`,
                        search: `?pipeline_id=null&filter_level_one=null&filter_level_two=null&filter_level_three=null&search_key=null`
                    });
                }
            }
            if (!currentPipelineId && !currentSearchKey) {
                setPageLoading(false);
            }

        } else {
            history({
                pathname: `/company/search-candidates`,
                search: `?pipeline_id=null&filter_level_one=null&filter_level_two=null&filter_level_three=null`
            });
        }
        // }
    }




    //load availeble filter settings of the pipeline
    const loadPipelineFilterSettings = async (currentPipelineId) => {

        if (pipelineListDropDownArray.length > 0 && currentPipelineId) {

            let selectedPipelineObjArray = (pipelineListDropDownArray).filter(function (el) {
                return el.value === currentPipelineId;
            });
            setCurrentPipelineObj(selectedPipelineObjArray[0]);

            setSelectedFilterLevelOneDropDownObj(null);
            setSelectedFilterLevelTwoDropDownObj(null);
            setSelectedFilterLevelThreeDropDownObj(null);

            setFilterLevelOneDropDownArray([]);
            setFilterLevelTwoDropDownArray([]);
            setFilterLevelThreeDropDownArray([]);

            let getCandidateFiltersRespond = await getCandidateFilters(currentPipelineId);
            if (getCandidateFiltersRespond.success === true) {
                setRootFilterSettingsObj(getCandidateFiltersRespond.data);


                //pass boolean value to identify the function of set URL parameter values as current objects
                setFilterLevelOneAvailable(true)
                setFilterLevelOneData(getCandidateFiltersRespond.data);
                getAllCandidatesByFilter();
                // setPageLoading(false);
            } else {

                history({
                    pathname: `/company/search-candidates`,
                    search: `?pipeline_id=${currentPipelineId}&filter_level_one=null&filter_level_two=null&filter_level_three=null&search_key=null`
                });
            }
        }
        else {
            setFilterLevelOneAvailable(false);
            setCurrentPipelineObj(null);
        }

    }


    const setFilterLevelOneData = () => {

        if (rootFilterSettingsObj && rootFilterSettingsObj.filters) {

            setSelectedFilterLevelTwoDropDownObj(null);
            setSelectedFilterLevelThreeDropDownObj(null);

            setFilterLevelTwoDropDownArray([]);
            setFilterLevelThreeDropDownArray([]);

            setFilterLevelTwoAvailable(false);
            setFilterLevelThreeAvailable(false);

            setLevelOneFilterError(false);

            setTableActions([]);

            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_one_filters = rootFilterSettingsObj.filters;
            let filter_level_one_array = [];
            let filter_level_one_action_array = [];

            let selected_filter_level_one_drop_down_obj = null;
            let selected_filter_level_one_obj = null;


            for (let index = 0; index < level_one_filters.length; index++) {
                let filterObj = {
                    label: level_one_filters[index].filter_label,
                    value: level_one_filters[index].filter_id
                }
                filter_level_one_array.push(filterObj);

                if (filter_level_one_url_paramater && (level_one_filters[index].filter_id == filter_level_one_url_paramater)) {
                    selected_filter_level_one_obj = level_one_filters[index];
                    selected_filter_level_one_drop_down_obj = filterObj;

                    if (selected_filter_level_one_obj.is_nested_filters_available) {
                        setFilterLevelTwoAvailable(true);
                    }
                    if (selected_filter_level_one_obj.is_actions_allowed) {
                        // filter_level_one_action_array.push(defaultActionObject);
                        for (let i = 0; i < selected_filter_level_one_obj.action_list.length; i++) {
                            let action_Obj = {
                                label: selected_filter_level_one_obj.action_list[i].action_label,
                                value: selected_filter_level_one_obj.action_list[i].action_id
                            }
                            filter_level_one_action_array.push(action_Obj)
                        }
                        setTableActions(filter_level_one_action_array);
                    }
                }
            }

            setTableActions([]);

            //set selected filter level one obj
            setFilterLevelOneObj(selected_filter_level_one_obj);

            //set filter level one array object (label / value data set) to a state
            setFilterLevelOneDropDownArray(filter_level_one_array);
            // set selected filter level one drop down object
            setSelectedFilterLevelOneDropDownObj(selected_filter_level_one_drop_down_obj);

            setPageLoading(false);
        }

    }


    //on change filter one dropdown
    const changeFilterLevelOne = (selected_filter_level_one) => {

        if (rootFilterSettingsObj && rootFilterSettingsObj.filters) {

            //reset future filters

            filter_level_one_url_paramater = null;
            filter_level_two_url_paramater = null;
            filter_level_three_url_paramater = null;

            setSelectedFilterLevelTwoDropDownObj(null);
            setSelectedFilterLevelThreeDropDownObj(null);

            setFilterLevelTwoDropDownArray([]);
            setFilterLevelThreeDropDownArray([]);

            setFilterLevelTwoAvailable(false);
            setFilterLevelThreeAvailable(false);

            setLevelOneFilterError(false);

            setTableActions([]);



            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_one_filters = rootFilterSettingsObj.filters;

            let selected_filter_level_one_drop_down_obj = null;
            let selected_filter_level_one_obj = null;


            for (let index = 0; index < level_one_filters.length; index++) {

                if (selected_filter_level_one && (level_one_filters[index].filter_id == selected_filter_level_one)) {

                    selected_filter_level_one_obj = level_one_filters[index];

                    let filterObj = {
                        label: level_one_filters[index].filter_label,
                        value: level_one_filters[index].filter_id
                    }
                    selected_filter_level_one_drop_down_obj = filterObj;

                    if (selected_filter_level_one_obj.is_nested_filters_available) {
                        setFilterLevelTwoAvailable(true);
                    }
                    if (selected_filter_level_one_obj.is_actions_allowed) {
                        setTableActions(selected_filter_level_one_obj.action_list);
                    }
                    break;
                }
            }

            //set selected filter level one obj
            setFilterLevelOneObj(selected_filter_level_one_obj)

            // set selected filter level one drop down object
            setSelectedFilterLevelOneDropDownObj(selected_filter_level_one_drop_down_obj);

        }


    }

    const setFilterLevelTwoData = () => {

        if (filterLevelOneObj && filterLevelOneObj.is_nested_filters_available && filterLevelOneObj.filters) {

            setFilterLevelThreeAvailable(false);
            setTableActions([]);

            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_two_filters = filterLevelOneObj.filters;
            let filter_level_two_array = [];
            let filter_level_two_action_array = [];

            let selected_filter_level_two_drop_down_obj = null;
            let selected_filter_level_two_obj = null;


            for (let index = 0; index < level_two_filters.length; index++) {
                let filterObj = {
                    label: level_two_filters[index].filter_label,
                    value: level_two_filters[index].filter_id
                }
                filter_level_two_array.push(filterObj);

                if (filter_level_two_url_paramater && (level_two_filters[index].filter_id == filter_level_two_url_paramater)) {

                    selected_filter_level_two_obj = level_two_filters[index];
                    selected_filter_level_two_drop_down_obj = filterObj;

                    if (selected_filter_level_two_obj.is_nested_filters_available) {
                        setFilterLevelThreeAvailable(true);
                    }
                    if (selected_filter_level_two_obj.is_actions_allowed) {
                        // filter_level_two_action_array.push(defaultActionObject);
                        for (let i = 0; i < selected_filter_level_two_obj.action_list.length; i++) {
                            let action_Obj = {
                                label: selected_filter_level_two_obj.action_list[i].action_label,
                                value: selected_filter_level_two_obj.action_list[i].action_id
                            }
                            filter_level_two_action_array.push(action_Obj)
                        }
                        setTableActions(filter_level_two_action_array);
                    }
                }
            }

            //set selected filter level one obj
            setFilterLevelTwoObj(selected_filter_level_two_obj)

            //set filter level one array object (label / value data set) to a state
            setFilterLevelTwoDropDownArray(filter_level_two_array);
            // set selected filter level one drop down object
            setSelectedFilterLevelTwoDropDownObj(selected_filter_level_two_drop_down_obj);

            //pass boolean value to identify the function of set URL parameter values as current objects
            // setFilterLevelThreeData();
        }

    }

    //on change filter one dropdown
    const changeFilterLevelTwo = (selected_filter_level_two) => {

        if (filterLevelOneObj && filterLevelOneObj.filters) {

            filter_level_two_url_paramater = null;
            filter_level_three_url_paramater = null;

            //reset future filters
            setSelectedFilterLevelThreeDropDownObj(null);
            setFilterLevelThreeDropDownArray([]);

            setLevelTwoFilterError(false);

            setFilterLevelThreeAvailable(false);
            setTableActions([]);


            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_two_filters = filterLevelOneObj.filters;

            let selected_filter_level_two_drop_down_obj = null;
            let selected_filter_level_two_obj = null;


            for (let index = 0; index < level_two_filters.length; index++) {

                if (selected_filter_level_two && (level_two_filters[index].filter_id == selected_filter_level_two)) {

                    selected_filter_level_two_obj = level_two_filters[index];

                    let filterObj = {
                        label: level_two_filters[index].filter_label,
                        value: level_two_filters[index].filter_id
                    }
                    selected_filter_level_two_drop_down_obj = filterObj;

                    if (selected_filter_level_two_obj.is_nested_filters_available) {
                        setFilterLevelThreeAvailable(true);
                    }
                    if (selected_filter_level_two_obj.is_actions_allowed) {
                        setTableActions(selected_filter_level_two_obj.action_list);
                    }
                    break;
                }
            }

            //set selected filter level one obj
            setFilterLevelTwoObj(selected_filter_level_two_obj)

            // set selected filter level one drop down object
            setSelectedFilterLevelTwoDropDownObj(selected_filter_level_two_drop_down_obj);
        }

    }

    const setFilterLevelThreeData = () => {

        if (filterLevelTwoObj && filterLevelTwoObj.is_nested_filters_available && filterLevelTwoObj.filters) {

            setTableActions([]);

            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_three_filters = filterLevelTwoObj.filters;
            let filter_level_three_array = [];
            let filter_level_three_action_array = [];

            let selected_filter_level_three_drop_down_obj = null;
            let selected_filter_level_three_obj = null;


            for (let index = 0; index < level_three_filters.length; index++) {
                let filterObj = {
                    label: level_three_filters[index].filter_label,
                    value: level_three_filters[index].filter_id
                }
                filter_level_three_array.push(filterObj);

                if (filter_level_three_url_paramater && (level_three_filters[index].filter_id == filter_level_three_url_paramater)) {
                    selected_filter_level_three_obj = level_three_filters[index];
                    selected_filter_level_three_drop_down_obj = filterObj;

                    if (selected_filter_level_three_obj.is_actions_allowed) {
                        // filter_level_three_action_array.push(defaultActionObject);
                        for (let i = 0; i < selected_filter_level_three_obj.action_list.length; i++) {
                            let action_Obj = {
                                label: selected_filter_level_three_obj.action_list[i].action_label,
                                value: selected_filter_level_three_obj.action_list[i].action_id
                            }
                            filter_level_three_action_array.push(action_Obj)
                        }
                        setTableActions(filter_level_three_action_array);
                    }
                }

            }

            //set selected filter level one obj
            setFilterLevelThreeObj(selected_filter_level_three_obj)

            //set filter level one array object (label / value data set) to a state
            setFilterLevelThreeDropDownArray(filter_level_three_array);
            // set selected filter level one drop down object
            setSelectedFilterLevelThreeDropDownObj(selected_filter_level_three_drop_down_obj);
        }

    }

    //on change filter one dropdown
    const changeFilterLevelThree = (selected_filter_level_three) => {

        if (filterLevelTwoObj && filterLevelTwoObj.filters) {

            filter_level_three_url_paramater = null;

            setLevelThreeFilterError(false);
            setTableActions([]);

            //prepare level one filter drop down array - using loop get stage array object (label / value data set)
            let level_three_filters = filterLevelTwoObj.filters;

            let selected_filter_level_three_drop_down_obj = null;
            let selected_filter_level_three_obj = null;


            for (let index = 0; index < level_three_filters.length; index++) {

                if (selected_filter_level_three && (level_three_filters[index].filter_id == selected_filter_level_three)) {

                    selected_filter_level_three_obj = level_three_filters[index];

                    let filterObj = {
                        label: level_three_filters[index].filter_label,
                        value: level_three_filters[index].filter_id
                    }
                    selected_filter_level_three_drop_down_obj = filterObj;

                    if (selected_filter_level_three_obj.is_actions_allowed) {
                        setTableActions(selected_filter_level_three_obj.action_list);
                    }

                    break;
                }
            }

            //set selected filter level one obj
            setFilterLevelThreeObj(selected_filter_level_three_obj)

            // set selected filter level one drop down object
            setSelectedFilterLevelThreeDropDownObj(selected_filter_level_three_drop_down_obj);
        }
    }

    //load all candidates according to filter parameters
    const getAllCandidatesByFilter = async () => {


        if (filter_level_one_url_paramater) {
            setDateLoading(true)
            let respond = await getFilteredCandidates(currentPipelineId, filter_level_one_url_paramater ? filter_level_one_url_paramater : null, filter_level_two_url_paramater ? filter_level_two_url_paramater : null, filter_level_three_url_paramater ? filter_level_three_url_paramater : null);
            if (respond.success === true) {
                let filteredCandidateArray = [];
                for (let index = 0; index < respond.data.length; index++) {
                    let filteredCandidateObj = {
                        id: respond.data[index].id,
                        name: respond.data[index].name,
                        email: respond.data[index].email,
                        phone: respond.data[index].phone,
                        overall_marks: respond.data[index].overall_marks,
                        state: respond.data[index].state,
                        state_code: respond.data[index].state_code,
                        candidate_profile_url: respond.data[index].candidate_profile_url,
                        candidate_state_code: respond.data[index].candidate_state_code,
                        evaluation_steps: respond.data[index].evaluation_steps,
                        current_stage_name: respond.data[index].current_stage_name,
                        last_stage_name: respond.data[index].last_stage_name,
                        hiring_position: respond.data[index].hiring_position,
                        pipeline_name: respond.data[index].pipeline_name,
                        is_enabled: false
                    }
                    filteredCandidateArray.push(filteredCandidateObj);
                }
                setOriginalData(filteredCandidateArray);
                const endOffset = itemOffset + itemsPerPage;
                setCurrentItems(filteredCandidateArray.slice(itemOffset, endOffset));
                setPageCount(Math.ceil(filteredCandidateArray.length / itemsPerPage));


                setFilteredTableData(filteredCandidateArray);
                setDateLoading(false)
            } else {
                setDateLoading(false)
                history({
                    pathname: `/company/search-candidates`,
                    search: `?pipeline_id=${currentPipelineId}&filter_level_one=null&filter_level_two=null&filter_level_three=null&search_key=null`
                });
            }
        }
    }

    //clicking on pagination
    // Invoke when user click to request another page.
    const handlePageClick = (event) => {

        const newOffset = (event.selected * itemsPerPage) % filteredtableData.length;
        setItemOffset(newOffset);
        const endOffset = newOffset + itemsPerPage;
        setCurrentItems(originalData.slice(newOffset, endOffset));

    };

    //view candidate
    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }

    //on action selected
    const onActionSelected = async (action_id, data_values) => {
        let candidate_id_array = [];
        let candidate_data_array = [];
        // loop to get candidate ids
        for (let index = 0; index < selectedCandidateIds.length; index++) {
            candidate_id_array.push(selectedCandidateIds[index].id);
        }

        if (action_id === MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION
            });
        }
        if (action_id === MANUALLY_REJECT_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_REJECT_IN_EVALUATION
            });
        }
        if (action_id === MANUALLY_PASS_FROM_FAILED_IN_EVALUATION) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: MANUALLY_PASS_FROM_FAILED_IN_EVALUATION
            });
        }

        if (action_id === REJECT_IN_FILTERD_STAGE) {
            setActionStateModal({
                is_open: true,
                candidate_id_set: candidate_id_array,
                action_state: REJECT_IN_FILTERD_STAGE
            });
        }

        if (action_id === SEND_BULK_EMAILS) {
            setShowBulkEmailsToCandidates(true);
            for (let index = 0; index < selectedCandidateIds.length; index++) {
                let candidate_object = {
                    candidate_id: selectedCandidateIds[index].id,
                    candidate_email: selectedCandidateIds[index].email,
                }
                candidate_data_array.push(candidate_object);
            }
            setCandidateData(candidate_data_array);
        }
    };


    //send single email to the candidate by clicking the icon
    const sendSingleEmail = (data_values) => {
        setShowBulkEmailsToCandidates(true);
        let candidate_data_array = [];

        let candidate_object = {
            candidate_id: data_values.id,
            candidate_email: data_values.email,
        }
        candidate_data_array.push(candidate_object);
        setCandidateData(candidate_data_array);

    }

    //set checkbox value
    const selectDeselectAttribute = (index) => {

        let actual_index = itemOffset + index;
        let copyOfOriginalData = [...originalData];

        for (let i = 0; i < copyOfOriginalData.length; i++) {

            //condition to check for loop i value and index
            if (parseInt(i) == parseInt(actual_index)) {
                let rowCount;
                setSelectedRowCount(rowCount);
                copyOfOriginalData[i].is_enabled = !copyOfOriginalData[i].is_enabled;
                break;
            }

        }

        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(copyOfOriginalData.slice(itemOffset, endOffset));
        setOriginalData(copyOfOriginalData);
        updateSelectedRowCount();
    };

    // update is_enabled true row count
    const updateSelectedRowCount = () => {

        let selected_candidate_id_array = []
        let selected_row_count = 0
        for (let i = 0; i < originalData.length; i++) {
            if (originalData[i].is_enabled) {
                selected_row_count = selected_row_count + 1;
                let enabledCandidateObj = {
                    id: originalData[i].id,
                    email: originalData[i].email
                }
                selected_candidate_id_array.push(enabledCandidateObj);
            }
        }
        setSelectedRowCount(selected_candidate_id_array.length);
        setSelectedCandidateIds(selected_candidate_id_array);
    };

    //set checkbox  value to sle
    const selectAllCandidate = () => {

        let copyOfOriginalData = [...originalData];
        let filteredOriginalData = []
        setSelectedRowCount(copyOfOriginalData.length);
        for (let i = 0; i < copyOfOriginalData.length; i++) {
            // filteredArray[i].is_enabled = !filteredArray[i].is_enabled;
            if(copyOfOriginalData[i].candidate_state_code === -100) {
                copyOfOriginalData[i].is_enabled = false;
            }
            else{
                copyOfOriginalData[i].is_enabled = !isSelectAllCandidate;
                filteredOriginalData.push(copyOfOriginalData[i])
            }
        }
        updateSelectedRowCount();
        setSelectAllCandidate(!isSelectAllCandidate)
        setFilteredTableData(filteredOriginalData);

    };



    //download the CV
    const downloadCVClick = async (candidate_id) => {
        // setIsDownloadCVPending(true);
        let respond = await getPresignedUrlToViewCandidateCV(candidate_id);
        if (respond.success === true) {
            if (respond.data.presigned_url) {
                // setIsDownloadCVPending(false);
                window.open(respond.data.presigned_url)
            } else {
                // setIsDownloadCVPending(false);
            }
        } else {
            // setIsDownloadCVPending(false);
        }
    }



    const handleClose = () => {
        setShowBulkEmailsToCandidates(false);
    };

    useEffect(() => {
        loadPageData();
    }, [currentPipelineId]);


    useEffect(() => {
        loadPipelineFilterSettings(currentPipelineId)
    }, [pipelineListDropDownArray, currentPipelineId]);


    useEffect(() => {
        setFilterLevelOneData()
    }, [rootFilterSettingsObj]);


    useEffect(() => {
        setFilterLevelTwoData()
    }, [filterLevelOneObj]);


    useEffect(() => {
        setFilterLevelThreeData()
    }, [filterLevelTwoObj]);

    useEffect(() => {
        loadPageData();
    }, [isFilterRenderStatus])

    useEffect(() => {
        loadPageData();
    }, [currentSearchKey])

    useEffect(() => {
        props.toggleInterviewView(true);
        let pageHit = '';
        pageHit = '/company/search-candidates';
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])

    useEffect(() => {
        const getCandidateAllDetails = async () => {
            setActionsSubmitLoading(true);
            
            if (currentItems && currentItems.length > 0) {
                const getCandidateId = currentItems[0].id;
                
                try {
                    let respond = await getCandidateDetails(getCandidateId);
                    if (respond.success) {
                        setCandidateDetailsValues(respond.data.candidate_details);
                    }
                } catch (error) {
                    console.error("Failed to fetch candidate details:", error);
                } finally {
                    setActionsSubmitLoading(false);
                }
            } else {
                setActionsSubmitLoading(false);
            }
        };
    
        getCandidateAllDetails();
    }, [currentItems]);
    
    useEffect(() => {
        const processBypassCandidateValues = () => {
            if (candidateDetailsValues.upcoming_pipeline_evaluation_steps_data.length > 0) {
                let evaluationStepslength = candidateDetailsValues.upcoming_pipeline_evaluation_steps_data.length;
                let selectionTypes = [];
                for (let index = 0; index < evaluationStepslength; index++) {
                    let data = {};
                    if (index === 0) {
                        data = {
                            value: candidateDetailsValues.current_stage_id === null
                                ? candidateDetailsValues.last_evaluation_pipeline_step
                                : candidateDetailsValues.current_stage_id,
                            label: candidateDetailsValues.upcoming_pipeline_evaluation_steps_data[index].step_name
                        };
                        setDefaultSelectBypassDropdownEvaluationStep(data);
                    } else {
                        data = {
                            value: candidateDetailsValues.upcoming_pipeline_evaluation_steps_data[index - 1]._id,
                            label: candidateDetailsValues.upcoming_pipeline_evaluation_steps_data[index].step_name
                        };
                    }
                    selectionTypes.push(data);
                }
                // Add "Filter stage" at the end
                selectionTypes.push({
                    value: -1,
                    label: "Filter stage"
                });
                setBypassDropdownEvaluationSelectionTypes(selectionTypes);
            } else {
                let selectionTypes = [];
                let data = {
                    value: candidateDetailsValues.current_stage_id === null ? -1 : candidateDetailsValues.current_stage_id,
                    label: "Filter stage"
                };
                setDefaultSelectBypassDropdownEvaluationStep(data);
                selectionTypes.push(data);
                setBypassDropdownEvaluationSelectionTypes(selectionTypes);
            }
        };
    
        if (candidateDetailsValues) {
            processBypassCandidateValues();
        }
    }, [candidateDetailsValues]);
    
    return (
        <div>
            
             <Helmet>
                <title>Search Candidates | HireTrace</title>
            </Helmet>

            {isPageLoading === true || isDataLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div className={styles.mainContainer}>
                    {showBulkEmailsToCandidates &&
                        <SendBulkEmailsToCandidates showModal={showBulkEmailsToCandidates} handleClose={handleClose} candidateData={candidateData} loadPageData={loadPageData} />
                    }

                    {/* Manually fail from filter step confirmation popup box start */}
                    <CustomConfirmationBox
                        show={actionStateModal.is_open && actionStateModal.action_state === REJECT_IN_FILTERD_STAGE}
                        cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onFormSubmit={manuallyFailFromFilterStep}
                        isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Are you sure?"
                        message="You are trying to manually reject selected candidate(s) from the pipeline. Candidate(s) overall status will be failed"
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, reject candidate"
                        checkboxLabel="I confirm to manually reject selected candidate(s) from the pipeline"
                        textInputPlaceholder="Ex: Candidate Does Not Meet Required Expectations"
                    />
                    {/* Manually fail from filter step confirmation popup box end */}

                    {/* Manually pass pipeline step confirmation popup box start */}
                    <CustomConfirmationWithDropdownBox
                        show={actionStateModal.is_open && (actionStateModal.action_state === MANUALLY_PASS_TO_NEXT_STEP_IN_EVALUATION)}
                        cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onFormSubmit={manualPassToUpcomingStep}
                        isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Are you sure?"
                        message="You are trying to manually pass selected candidate(s) from current stage to the upcoming stages."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, pass step!"
                        checkboxLabel="I confirm to manually pass selected candidate from pipeline step"
                        dropDownLabel="Select evaluation step"
                        confirmationType="success"
                        defaultSelectStep={defaultSelectBypassDropdownEvaluationStep}
                        selectionTypes={bypassDropdownEvaluationSelectionTypes}
                    />


                    {/* Manually fail pipeline step confirmation popup box start */}
                    <CustomConfirmationBox
                        show={actionStateModal.is_open && actionStateModal.action_state === MANUALLY_REJECT_IN_EVALUATION}
                        cancelIconclick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onSecondaryBtnClick={() => setActionStateModal({ is_open: false, action_state: '', candidate_id_set: [] })}
                        onFormSubmit={manuallyFailFromCurrentStep}
                        isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Are you sure?"
                        message="You are trying to manually reject selected candidate(s) from the pipeline. Candidate(s) overall status will be failed"
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, reject candidate"
                        checkboxLabel="I confirm to manually reject selected candidate(s) from the pipeline"
                        textInputPlaceholder="Ex: Candidate Does Not Meet Required Expectations"
                    />
                    {/* Manually fail pipeline step confirmation popup box end */}


                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>

                    </div>

                    <Row className={styles.bodyContainer}>
                        <div sm={3} md={3} lg={3} xl={3} className={styles.leftSideOptionsDiv}>
                            <div className={styles.leftSideOptionsInnerDiv}>


                                {/* if NOT search ,mode */}
                                {!is_search_mode &&
                                    <div>
                                        <span className={styles.subCategoryTopic}>Filters</span>

                                        <Formik
                                            enableReinitialize
                                            onSubmit={(values) => onSubmitFilter(values)}
                                            initialValues={{ pipeline: currentPipelineObj, filter_level_one: selectedFilterLevelOneDropDownObj, filter_level_two: selectedFilterLevelTwoDropDownObj, filter_level_three: selectedFilterLevelThreeDropDownObj }}>

                                            {({
                                                values,
                                                errors,
                                                handleChange,
                                                handleSubmit,
                                                setFieldValue,
                                                submitCount
                                            }) => (
                                                <Form noValidate onSubmit={handleSubmit}>
                                                    <div className='mt-3 mb-5'>

                                                        <Row>

                                                            <Col className='mb-3'>
                                                                <Form.Label className={styles.defaultLabel}>
                                                                    Pipeline
                                                                </Form.Label>
                                                                <Select
                                                                    options={pipelineListDropDownArray}
                                                                    name="filter_level_two"
                                                                    class="react-select__control"
                                                                    components={animatedComponents}
                                                                    value={values.pipeline}
                                                                    onChange={(e) => { changeSelectedPipeline(e.value); setFieldValue('pipeline', e.value) }}
                                                                    styles={
                                                                        isLevelTwoFilterError ?
                                                                            {
                                                                                ...styles,
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                                                    border: '1px solid #dc3545', // default border color
                                                                                    borderRadius: '6px',
                                                                                    boxShadow: 'none', // no box-shadow
                                                                                }),
                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                    return {
                                                                                        ...styles,
                                                                                        background: isDisabled
                                                                                            ? null
                                                                                            : isSelected
                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                : isFocused
                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                    : null,
                                                                                        color: isDisabled
                                                                                            ? '#ccc'
                                                                                            : isSelected
                                                                                                ? '#24859A'
                                                                                                : '#24859A',
                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                        ':active': {
                                                                                            ...styles[':active'],
                                                                                            background:
                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                        },
                                                                                    };
                                                                                },
                                                                            }
                                                                            :
                                                                            {
                                                                                ...styles,
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                                    border: '1px solid #bdbdbd', // default border color
                                                                                    borderRadius: '6px',
                                                                                    boxShadow: 'none', // no box-shadow
                                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                                    fontWeight: 'var(--app-regular-font-weight)',
                                                                                    fontSize: 'var(--app-semi-small-font-size)'
                                                                                }),
                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                    return {
                                                                                        ...styles,
                                                                                        fontFamily: 'var(--app-primary-font-style)',
                                                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                                                        fontSize: 'var(--app-semi-small-font-size)',
                                                                                        background: isDisabled
                                                                                            ? null
                                                                                            : isSelected
                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                : isFocused
                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                    : null,
                                                                                        color: isDisabled
                                                                                            ? '#ccc'
                                                                                            : isSelected
                                                                                                ? '#24859A'
                                                                                                : '#24859A',
                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                        ':active': {
                                                                                            ...styles[':active'],
                                                                                            background:
                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                        },
                                                                                    };
                                                                                },
                                                                            }
                                                                    }
                                                                />

                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            {isFilterLevelOneAvailable &&
                                                                <Col className='mb-3'>
                                                                    <Form.Label className={styles.defaultLabel}>
                                                                        Stage
                                                                    </Form.Label>
                                                                    <Select
                                                                        options={filterLevelOneDropDownArray}
                                                                        name="filter_level_two"
                                                                        class="react-select__control"
                                                                        components={animatedComponents}
                                                                        value={values.filter_level_one}
                                                                        onChange={(e) => { changeFilterLevelOne(e.value); setFieldValue('filter_level_one', e.value) }}
                                                                        styles={
                                                                            isLevelOneFilterError ?
                                                                                {
                                                                                    ...styles,
                                                                                    control: (base, state) => ({
                                                                                        ...base,
                                                                                        '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                                                        border: '1px solid #dc3545', // default border color
                                                                                        borderRadius: '6px',
                                                                                        boxShadow: 'none', // no box-shadow
                                                                                    }),
                                                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                        return {
                                                                                            ...styles,
                                                                                            background: isDisabled
                                                                                                ? null
                                                                                                : isSelected
                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                    : isFocused
                                                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                                                        : null,
                                                                                            color: isDisabled
                                                                                                ? '#ccc'
                                                                                                : isSelected
                                                                                                    ? '#24859A'
                                                                                                    : '#24859A',
                                                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                            ':active': {
                                                                                                ...styles[':active'],
                                                                                                background:
                                                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                            },
                                                                                        };
                                                                                    },
                                                                                }
                                                                                :
                                                                                {
                                                                                    ...styles,
                                                                                    control: (base, state) => ({
                                                                                        ...base,
                                                                                        '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                                        border: '1px solid #bdbdbd', // default border color
                                                                                        borderRadius: '6px',
                                                                                        boxShadow: 'none', // no box-shadow
                                                                                        fontFamily: 'var(--app-primary-font-style)',
                                                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                                                        fontSize: 'var(--app-semi-small-font-size)'
                                                                                    }),
                                                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                        return {
                                                                                            ...styles,
                                                                                            fontFamily: 'var(--app-primary-font-style)',
                                                                                            fontWeight: 'var(--app-regular-font-weight)',
                                                                                            fontSize: 'var(--app-semi-small-font-size)',
                                                                                            background: isDisabled
                                                                                                ? null
                                                                                                : isSelected
                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                    : isFocused
                                                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                                                        : null,
                                                                                            color: isDisabled
                                                                                                ? '#ccc'
                                                                                                : isSelected
                                                                                                    ? '#24859A'
                                                                                                    : '#24859A',
                                                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                            ':active': {
                                                                                                ...styles[':active'],
                                                                                                background:
                                                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                            },
                                                                                        };
                                                                                    },
                                                                                }
                                                                        }
                                                                    />

                                                                </Col>}
                                                        </Row>
                                                        <Row>

                                                            {isFilterLevelTwoAvailable && <Col className='mb-3'>
                                                                <Form.Label className={styles.defaultLabel}>
                                                                    Filter 1
                                                                </Form.Label>
                                                                <Select
                                                                    options={filterLevelTwoDropDownArray}
                                                                    name="filter_level_two"
                                                                    class="react-select__control"
                                                                    components={animatedComponents}
                                                                    value={values.filter_level_two}
                                                                    onChange={(e) => { changeFilterLevelTwo(e.value); setFieldValue('filter_level_two', e.value) }}
                                                                    styles={
                                                                        isLevelTwoFilterError ?
                                                                            {
                                                                                ...styles,
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                                                    border: '1px solid #dc3545', // default border color
                                                                                    borderRadius: '6px',
                                                                                    boxShadow: 'none', // no box-shadow
                                                                                }),
                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                    return {
                                                                                        ...styles,
                                                                                        background: isDisabled
                                                                                            ? null
                                                                                            : isSelected
                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                : isFocused
                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                    : null,
                                                                                        color: isDisabled
                                                                                            ? '#ccc'
                                                                                            : isSelected
                                                                                                ? '#24859A'
                                                                                                : '#24859A',
                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                        ':active': {
                                                                                            ...styles[':active'],
                                                                                            background:
                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                        },
                                                                                    };
                                                                                },
                                                                            }
                                                                            :
                                                                            {
                                                                                ...styles,
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                                    border: '1px solid #bdbdbd', // default border color
                                                                                    borderRadius: '6px',
                                                                                    boxShadow: 'none', // no box-shadow
                                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                                    fontWeight: 'var(--app-regular-font-weight)',
                                                                                    fontSize: 'var(--app-semi-small-font-size)'
                                                                                }),
                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                    return {
                                                                                        ...styles,
                                                                                        fontFamily: 'var(--app-primary-font-style)',
                                                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                                                        fontSize: 'var(--app-semi-small-font-size)',
                                                                                        background: isDisabled
                                                                                            ? null
                                                                                            : isSelected
                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                : isFocused
                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                    : null,
                                                                                        color: isDisabled
                                                                                            ? '#ccc'
                                                                                            : isSelected
                                                                                                ? '#24859A'
                                                                                                : '#24859A',
                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                        ':active': {
                                                                                            ...styles[':active'],
                                                                                            background:
                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                        },
                                                                                    };
                                                                                },
                                                                            }
                                                                    }
                                                                />

                                                            </Col>
                                                            }
                                                        </Row>
                                                        <Row>

                                                            {isFilterLevelThreeAvailable && <Col className='mb-3'>
                                                                <Form.Label className={styles.defaultLabel}>
                                                                    Filter 2
                                                                </Form.Label>
                                                                <Select
                                                                    options={filterLevelThreeDropDownArray}
                                                                    name="filter_level_two"
                                                                    class="react-select__control"
                                                                    components={animatedComponents}
                                                                    value={values.filter_level_three}
                                                                    onChange={(e) => { changeFilterLevelThree(e.value); setFieldValue('filter_level_three', e.value) }}
                                                                    styles={
                                                                        isLevelThreeFilterError ?
                                                                            {
                                                                                ...styles,
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                                                    border: '1px solid #dc3545', // default border color
                                                                                    borderRadius: '6px',
                                                                                    boxShadow: 'none', // no box-shadow
                                                                                }),
                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                    return {
                                                                                        ...styles,
                                                                                        background: isDisabled
                                                                                            ? null
                                                                                            : isSelected
                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                : isFocused
                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                    : null,
                                                                                        color: isDisabled
                                                                                            ? '#ccc'
                                                                                            : isSelected
                                                                                                ? '#24859A'
                                                                                                : '#24859A',
                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                        ':active': {
                                                                                            ...styles[':active'],
                                                                                            background:
                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                        },
                                                                                    };
                                                                                },
                                                                            }
                                                                            :
                                                                            {
                                                                                ...styles,
                                                                                control: (base, state) => ({
                                                                                    ...base,
                                                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                                    border: '1px solid #bdbdbd', // default border color
                                                                                    borderRadius: '6px',
                                                                                    boxShadow: 'none', // no box-shadow
                                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                                    fontWeight: 'var(--app-regular-font-weight)',
                                                                                    fontSize: 'var(--app-semi-small-font-size)'
                                                                                }),
                                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                                    return {
                                                                                        ...styles,
                                                                                        fontFamily: 'var(--app-primary-font-style)',
                                                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                                                        fontSize: 'var(--app-semi-small-font-size)',
                                                                                        background: isDisabled
                                                                                            ? null
                                                                                            : isSelected
                                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                                : isFocused
                                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                                    : null,
                                                                                        color: isDisabled
                                                                                            ? '#ccc'
                                                                                            : isSelected
                                                                                                ? '#24859A'
                                                                                                : '#24859A',
                                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                                        ':active': {
                                                                                            ...styles[':active'],
                                                                                            background:
                                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                                        },
                                                                                    };
                                                                                },
                                                                            }
                                                                    }
                                                                />

                                                            </Col>}
                                                        </Row>

                                                        <div className='mt-4'>
                                                            <CustomButton
                                                                buttonType="submit"
                                                                type="primarySmallBtn"
                                                                label="Apply Filters"
                                                            />
                                                        </div>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>

                                    </div>
                                }
                                {/* if search ,mode */}
                                {is_search_mode &&
                                    <div>
                                        <span className={styles.subCategoryTopic}>Search</span>
                                        <div className='mb-5'>
                                            <div className='mb-3'>
                                                <CustomTextField
                                                    label="Search  Candidates by Name or Email"
                                                    classLabel="defaultLabel"
                                                    controlId="city"
                                                    type="text"
                                                    value={searchValue}
                                                    name="city"
                                                    classType="defaultTextBox"
                                                    handleOnChange={(e) => setSearchValue((e.target.value))}
                                                />
                                            </div>

                                            <CustomButton
                                                buttonType="button"
                                                type="primarySmallBtn"
                                                label="Search"
                                                handleClick={() => applySearchKey()}
                                            />

                                        </div>
                                    </div>
                                }


                            </div>
                        </div>
                        <div sm={7} lg={8} xl={9} className={styles.rightSideOptionsDiv}>

                            <div className={styles.rightSideOptionsInnerDiv}>

                                <Row className='mb-0'>
                                    <Col className={styles.selectAllCheckBoxCol}>
                                        <div className={styles.checkboxdiv}>
                                            <CustomCheckBox
                                                id="selectAllCandidates"
                                                label="Select All"
                                                controlId="selectAllCandidates"
                                                name="selectAllCandidates"
                                                handleOnChange={() => { selectAllCandidate() }}
                                                type="defaultCheckBox"
                                                ischecked={selectedRowCount === 0 || selectedRowCount < filteredtableData.length ? false : true}
                                            />
                                        </div>

                                    </Col>
                                    <Col lg={2} md={2} className={styles.selectedRowCountCol} >
                                        <p className={styles.selectedRowCount}>{selectedRowCount} Rows Selected</p>
                                    </Col>
                                    <Col lg={3} md={3} className={styles.actionsDropDownBoxCol}>
                                        <Select
                                            options={[...tableActions, defaultActionObject]}
                                            class="react-select__control"
                                            id="adminPanel_candidateSearch_actionsDropdownId"
                                            components={animatedComponents}
                                            isDisabled={selectedRowCount === 0 ? true : false}
                                            onChange={(e) => { onActionSelected(e.value) }}
                                            placeholder="Actions"
                                            styles={
                                                {
                                                    ...styles,
                                                    control: (base, state) => ({
                                                        ...base,
                                                        '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                        border: '1px solid #bdbdbd', // default border color
                                                        borderRadius: '6px',
                                                        boxShadow: 'none', // no box-shadow
                                                        height: '20px',
                                                        fontFamily: 'var(--app-primary-font-style)',
                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                        fontSize: 'var(--app-primary-font-size  )',
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                        return {
                                                            ...styles,
                                                            background: isDisabled
                                                                ? null
                                                                : isSelected
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : isFocused
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : null,
                                                            color: isDisabled
                                                                ? '#ccc'
                                                                : isSelected
                                                                    ? '#24859A'
                                                                    : '#24859A',
                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                            ':active': {
                                                                ...styles[':active'],
                                                                background:
                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                            },
                                                        };
                                                    },
                                                }
                                            }
                                        />
                                    </Col>



                                </Row>
                                {isSearchDataLoading === true ?
                                    (<div className={styles.loadingDiv}>
                                        <Col sm={{ span: 4, offset: 4 }}>
                                            <CSSLoader />
                                        </Col>
                                    </div>)
                                    :
                                    (<div className={styles.bodyContainerMain}>
                                        {currentItems.length !== 0 ?
                                            (currentItems.map((value, index) => (


                                                <div className={styles.bodyContainerBox}>
                                                    <Row className='mt-0 mb-0'>
                                                        <Col sm={6} lg={1}>
                                                            <div>
                                                                <Avatar src={value.candidate_profile_url || value.name ? value.candidate_profile_url : `${process.env.REACT_APP_FRONTEND_BASE_URL}/images/avatar.png`} name={value.name} size="70" round={false} />
                                                            </div>
                                                        </Col>

                                                        <Col className='ms-3'>
                                                            <Row>

                                                                <Col className='ml-4 p-0'>
                                                                    <Row className='mt-0 p-0'>
                                                                        <div className="d-flex flex-row justify-content-start align-item-start flex-wrap  mt-0 p-0">
                                                                            <div className={styles.nameContainer}>
                                                                                <CustomCheckBox
                                                                                    id={`value.${index}.is_enabled`}
                                                                                    controlId={`adminPanel_candidateSearch_candidateSelectCheckBoxId.${index}`}
                                                                                    name={`value.${index}.is_enabled`}
                                                                                    handleOnChange={() => selectDeselectAttribute(index)}
                                                                                    type="defaultCheckBox"
                                                                                    value={value.is_enabled}
                                                                                    ischecked={value.is_enabled ? true : false}
                                                                                    disabled={value.candidate_state_code === -100 ? true : false}
                                                                                />

                                                                            </div>
                                                                            <div className={styles.nameTextDiv}><p onClick={(e) => { e.preventDefault(); viewCandidate(value.id) }}><a href="#" tabindex="-1" aria-disabled="true" className={styles.nameTextLink} id={`adminPanel_candidateSearch_candidateNameId.${index}`}>{value.name ? value.name : "-"}</a></p></div>
                                                                        </div>
                                                                    </Row>
                                                                    <Row className={styles.pipelineNameDiv}>
                                                                        <span className={styles.positionText}>{value.pipeline_name}</span>

                                                                    </Row>
                                                                    <Row className='mb-n1 pt-0'>
                                                                        <span className={styles.emailText}>{value.email} &nbsp;&nbsp;| &nbsp;&nbsp;{value.phone ? value.phone : "-"}</span>
                                                                    </Row>
                                                                </Col>
                                                            </Row>



                                                        </Col>
                                                        <Col md={2} ml={0} className={styles.scoreColumn} >
                                                            <p className='text-right mb-0 pt-0 mr-6'><span className={styles.scoreNoText}>  {value.overall_marks ? value.overall_marks : 0}%</span></p>
                                                            <p className='text-right'><span className={styles.scoreText}>OVERALL SCORE  </span></p>
                                                        </Col>
                                                        <Col md={{ offset: 1 }} className={styles.actionColoumn}>
                                                            <Row className='w-100'>
                                                                <Col className="m-0">
                                                                    {value.state_code === 10 || value.state_code === 0 ?
                                                                        <Alert variant="warning" className={styles.badgeTypeWarning}>{value.state}</Alert>
                                                                        : value.state_code === 20 ?
                                                                            <Alert variant="success" className={styles.badgeType}>{value.state}</Alert>
                                                                            : value.state_code === -10 ?
                                                                                <Alert variant="danger" className={styles.badgeTypeDanger}>{value.state}</Alert>
                                                                                : value.state_code === -10 ?
                                                                                    <Alert variant="danger" className={styles.badgeTypeDanger}>{value.state}</Alert>
                                                                                    : value.state_code === 30 ?
                                                                                        <Alert variant="success" className={styles.badgeType}>{value.state}</Alert>
                                                                                        : value.state_code === -60 ?
                                                                                            <Alert variant="danger" className={styles.badgeTypeDanger}>{value.state}</Alert>
                                                                                            : null}
                                                                </Col>

                                                            </Row>
                                                            <Row>
                                                                <Col className='m-0'>
                                                                    <div className="d-flex flex-row justify-content-around align-item-start flex-wrap mr-3 mt-3 p-0">
                                                                        <div className={styles.iconRow} data-tooltip-id={`downloadCv`}>

                                                                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => downloadCVClick(value.id)} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download-cloud"><polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path></svg>

                                                                        </div>
                                                                        <ReactTooltip id={`downloadCv`} place="left" type="dark" effect="solid">
                                                                            <span>{"Download CV"}</span>
                                                                        </ReactTooltip>

                                                                        <div className={styles.iconRow} data-tooltip-id={`sendEmail`}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => sendSingleEmail(value)} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>

                                                                        </div>
                                                                        <ReactTooltip id={`sendEmail`} place="left" type="dark" effect="solid">
                                                                            <span>{"Send Email"}</span>
                                                                        </ReactTooltip>

                                                                        <div className={styles.iconRow} data-tooltip-id={`viewProfile`}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => viewCandidate(value.id)} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>

                                                                        </div>
                                                                        <ReactTooltip id={`viewProfile`} place="left" type="dark" effect="solid">
                                                                            <span>{"View profile"}</span>
                                                                        </ReactTooltip>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )))
                                            :
                                            (
                                                <div className={styles.bodySecondContainerBox}>
                                                    <p className={styles.infoMessage}>No records found for your search, Try a different name or email. </p>
                                                </div>
                                            )
                                        }
                                        {pageCount > 1 &&
                                            <div className={styles.paginationDiv}>
                                                <ReactPaginate className={styles.paginate}
                                                    breakLabel="..."
                                                    nextLabel=">"
                                                    onPageChange={handlePageClick}
                                                    pageRangeDisplayed={5}
                                                    pageCount={pageCount}
                                                    previousLabel="<"
                                                    renderOnZeroPageCount={null}
                                                    pageClassName="page-item"
                                                    pageLinkClassName="page-link"
                                                    previousClassName="page-item"
                                                    previousLinkClassName="page-link"
                                                    nextClassName="page-item"
                                                    nextLinkClassName="page-link"
                                                    breakClassName="page-item"
                                                    breakLinkClassName="page-link"
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                />
                                            </div>

                                        }
                                    </div>)
                                }
                            </div>
                        </div>
                    </Row>

                </div >)}
        </div>
    )
}

export default CandidateSearch